import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { ScrollbarWrapper } from "../../../../../../components/ScrollbarWrapper";
import Scrollbar from "smooth-scrollbar";
import CambridgeIcon from "../../../../../../assets/icons/Cambridge icon.svg";
import JuniorIcon from "../../../../../../assets/icons/Junior icon.svg";
import KidsBoxIcon from "../../../../../../assets/icons/Kids Box icon.svg";
import SuperSafariIcon from "../../../../../../assets/icons/Super Safari icon.svg";

const IconPicker = ({ name, label, selectedValue, disabled, required, error, onChange, searchVisible = true, hint }) => {
    const icons = [
        { id: 1, value: "ICON_JUNIOR", name: "Junior", icon: SuperSafariIcon},
        { id: 2, value: "ICON_KIDS_BOX", name: "Kids box" , icon: JuniorIcon},
        { id: 3, value: "ICON_SUPER_SAFARI", name: "Super safari", icon: KidsBoxIcon },
        { id: 4, value: "ICON_CAMBRIDGE", name: "Cambridge", icon: CambridgeIcon },
    ];

    const [selectDown, isSelectDown] = useState(false);
    const [selectedOption, setSelectedOption] = useState(selectedValue);
    const [selectedOptionName, setSelectedOptionName] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const selectRef = useRef(null);
    const scrollbarRef = useRef(null);
    const [scrollActive, setScrollActive] = useState(true);
    const [hasVisibleTrack, setHasVisibleTrack] = useState(false);
    const [resetValue, setResetValue] = useState("");

    const selectToggle = () => {
        isSelectDown(!selectDown);
    };

    const handleOptionChange = (option) => {
            setSelectedOptionName(option.name);
            setSelectedOption(option.id);
  
        onChange({ target: { name, value: option } });
        isSelectDown(false);
        setResetValue("");
        setSearchTerm("");
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setResetValue(event.target.value);
    };

    const handleClickOutside = (event) => {
        if (selectRef.current && !selectRef.current.contains(event.target)) {
            isSelectDown(false);
        }
    };

    const handleResize = () => {
        setWindowWidth(window.innerWidth);
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        window.addEventListener("resize", handleResize);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        const comparedOption = icons.find((o) => o.value === selectedValue);
        if (comparedOption) {
            setSelectedOptionName(comparedOption.name);
            setSelectedOption(comparedOption.id);
        }
    }, [selectedValue, icons]);

    useLayoutEffect(() => {
        if (scrollbarRef?.current) {
            Scrollbar.init(scrollbarRef?.current, {
                damping: 0.1,
                thumbMinSize: 20,
                renderByPixels: true,
                continuousScrolling: "auto",
                alwaysShowTracks: true,
                delegateTo: null,
                plugins: {},
            });

            function setupScrollbar(options = {}) {
                const scrollbar = Scrollbar.get(scrollbarRef?.current);
                if (!scrollbar) return;

                if (options.removeXTrack && scrollbar.track.xAxis.element) {
                    scrollbar.track.xAxis.element.remove();
                }
                if (options.removeYTrack && scrollbar.track.yAxis.element) {
                    scrollbar.track.yAxis.element.remove();
                }

                let isScrolling;
                scrollbar.addListener(() => {
                    setScrollActive(true);

                    clearTimeout(isScrolling);
                    isScrolling = setTimeout(() => {
                        setScrollActive(false);
                    }, 200);
                });

                const toggleScrollbarClass = () => {
                    const tracks = scrollbarRef?.current?.querySelectorAll(`#mainContentScrollbar > .scrollbar-track`);

                    const hasVisibleTrack = tracks?.length > 0 && Array.from(tracks).some((track) => getComputedStyle(track).display === "block");

                    if (hasVisibleTrack) {
                        setHasVisibleTrack(true);
                    } else {
                        setHasVisibleTrack(false);
                    }
                };

                const tracks = scrollbarRef?.current?.querySelectorAll(`#mainContentScrollbar > .scrollbar-track`);
                const observer = new MutationObserver(() => {
                    toggleScrollbarClass();
                });

                tracks.forEach((track) => {
                    observer.observe(track, { attributes: true, attributeFilter: ["style"] });
                });

                if (!!options?.observeResize) {
                    const resizeTarget = document.querySelector(options.observeResize);
                    if (resizeTarget) {
                        const resizeObserver = new ResizeObserver(() => {
                            setTimeout(() => {
                                scrollbar.update();
                            }, 1000);
                            toggleScrollbarClass();
                        });
                        resizeObserver.observe(resizeTarget);
                    }
                }
            }

            setupScrollbar(icons);
        }
    }, []);
    return (
        <>
            <label htmlFor={`input-${name}`} className={`${required ? "input-required" : ""}`}>
                {label}
            </label>
            <div className={`dropdown dropdown--select ${disabled ? "colorpicker-disabled" : ""}`} style={{ width: "100%" }} ref={selectRef}>
                <div className="dropdown__toggle" onClick={selectToggle}>
                    {selectedOptionName || ""}
                </div>
                <div className={`dropdown__menu ${selectDown ? "active" : ""}`}>
                    {searchVisible ? <input type="text" className="dropdown__menu__search" placeholder="Search option" onChange={handleSearchChange} disabled={disabled} /> : ""}
                    <div
                        ref={scrollbarRef}
                        id="mainContentScrollbar"
                        className={`dropdown__menu__wrap ${scrollActive ? "active-scroll" : ""} ${hasVisibleTrack ? "scrollbar-on" : ""}`}
                        data-scrollbar
                    >
                        <div className="scroll-content">
                            {icons.map((option, index) => (
                                <div
                                    className="dropdown__menu__item"
                                    key={`${option?.id}-${index}`}
                                    data-value={option?.name}
                                    onClick={() => !disabled && handleOptionChange(option?.value)}
                                    style={{ display: option.name.toLowerCase().includes(searchTerm.toLowerCase()) ? "" : "none" }}
                                >
                                    <div class="dropdown__menu__item-img">
                                        <img src={option.icon}></img>
                                    </div>
                                    <span>{option?.name}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {hint && <div className="hint-message-text">{hint}</div>}
            {error && <div className="error-message-text">{error}</div>}
        </>
    );
};

export default IconPicker;
